import styles from '@ui/components/Select/Select.module.scss';
import Arrow from '../../../assets/icons/dropdown-arrow.inline.svg';
import SelectLabelMultiple from '@ui/components/Select/components/SelectLabelMultiple';
import SelectLabelSingle from '@ui/components/Select/components/SelectLabelSingle';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import classNames from 'classnames';
import React from 'react';

const SelectItems = ({
  selectedItem,
  hasIcons,
  placeholder,
  hasOutline,
  open,
  items,
  multiple,
}) => {
  const SelectLabel = multiple ? SelectLabelMultiple : SelectLabelSingle;

  return (
    <>
      <SelectLabel
        hasIcons={hasIcons}
        items={items}
        placeholder={placeholder}
        selectedItem={selectedItem}
      />
      {hasOutline ? (
        <FontAwesomeProIcon
          className={classNames(styles.icon, styles.arrow, {
            [styles.active]: open,
          })}
          icon="chevron-down"
        />
      ) : (
        <Arrow
          className={classNames(styles.arrow, {
            [styles.active]: open,
          })}
        />
      )}
    </>
  );
};

export default SelectItems;
